<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center">
      <v-select
        v-model="select"
        :items="filteredItems"
        :label="inputPlaceholder"
        item-text="city"
        item-value="id"
        return-object
        :item-disabled="isItemDisabled"
        @change="emit"
      >
        <template v-slot:prepend-item v-if="searchActive">
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                hide-details
                prepend-icon="icon-search"
                :placeholder="$t('message.common.find')"
                full-width
                v-model="search"
                single-line
              >
              </v-text-field>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:selection="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-content>{{ data.item }}</v-list-item-content>
          </template>
          <template v-else>
            <slot name="selectedItem" :item="data.item"></slot>
          </template>
        </template>
        <template v-slot:item="data">
          <v-list-item
            :disabled="isItemDisabled(data.item)"
            v-bind="data.attrs"
            v-on="data.on"
          >
            <v-list-item-content>
              <slot name="allItems" :item="data.item"></slot>
            </v-list-item-content>
            <v-list-item-action v-if="isItemDisabled(data.item)">
              <v-tooltip max-width="300px" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small color="grey"
                    >mdi-information</v-icon
                  >
                </template>
                <span>{{ $t("message.common.areaFacilityTooltip") }}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-select>
      <ui-button
        v-if="buttonName"
        color="primary"
        class="ml-5"
        :class="{ 'w-100': $vuetify.breakpoint.xsOnly }"
        @click="handleBtnClick"
        icon="icon-plus"
      >
        {{ buttonName }}
      </ui-button>
    </v-col>
  </v-row>
</template>

<script>
import { gtmEvent__buttonClick } from "@/helpers/gtm-events";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { BUSINESS_TYPE } from "@/enums/business-type.enum";
export default {
  name: "VisibilitySummarySelectBar",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectedItem: {
      type: Object,
      default: () => {}
    },
    inputPlaceholder: {
      type: String,
      required: true
    },
    buttonName: {
      type: String,
      default: ""
    },
    buttonSlug: {
      type: String,
      default: ""
    },
    buttonRouteName: {
      type: String,
      default: ""
    },
    searchActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      select: this.selectedItem,
      search: ""
    };
  },
  computed: {
    filteredItems() {
      if (this.searchActive) {
        return this.items.filter(item => {
          return (
            (item.name && item.name.toLowerCase().match(this.search)) ||
            (item.city && item.city.toLowerCase().match(this.search)) ||
            (item.url && item.url.toLowerCase().match(this.search)) ||
            (item.formatted_address &&
              item.formatted_address.toLowerCase().match(this.search))
          );
        });
      }
      return this.items;
    }
  },
  watch: {
    selectedItem: {
      immediate: true,
      handler(val) {
        this.select = val;
      }
    }
  },
  methods: {
    isItemDisabled(item) {
      return item.business_type === BUSINESS_TYPE.AREA;
    },
    emit(item) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.LOCATIONS_PICKER_SELECT,
        location_id: item.id
      });

      this.$emit("selected", item);
    },
    handleBtnClick() {
      if (this.buttonSlug) {
        gtmEvent__buttonClick({ label: this.buttonSlug });
      }

      this.$router.push({ name: this.buttonRouteName });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-list-item--disabled {
  pointer-events: none;

  .v-list-item__action {
    pointer-events: auto;
  }
}
</style>
